/**
 * Vendor marks the design shows on Settings (the device catalog, Connect stack and the
 * Models & Spend providers), bundled from design-preview/assets/console/logos so nothing
 * is fetched from elsewhere at runtime.
 */
const files = import.meta.glob('./logos/*.{png,svg,webp}', { eager: true, query: '?url', import: 'default' }) as Record<string, string>;
const BY_NAME: Record<string, string> = Object.fromEntries(Object.entries(files).map(([p, url]) => [p.replace('./logos/', ''), url]));

/** The bundled URL of a logo file, or '' when the file is not bundled. */
export function logoUrl(file: string): string {
  return BY_NAME[file] ?? '';
}

/** A logo as a CSS url(): double-quoted, so an inlined SVG data URI (which uses single quotes) stays whole. */
export function logoBg(file: string): string {
  return 'url("' + logoUrl(file).replace(/"/g, '%22') + '")';
}
